// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"8ac96e90","741":"abf749e3","782":"e9430290"}[chunkId] + ".chunk.css";
};